import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin, Calendar } from 'lucide-react';
import { useBusinessInfo } from '../../hooks/useBusinessInfo';

const CTASectionComponent = ({ config = {} }) => {
  const { businessInfo } = useBusinessInfo();
  const primaryColor = 'var(--theme-primary)';

  const title = config.title || 'Contact Us Today';
  const subtitle = config.subtitle || 'Schedule an appointment with our expert team';
  const buttonText = config.button_text || 'Book Now';
  const buttonLink = config.button_link || '/reach-us';
  const showPhone = config.show_phone !== false;
  const backgroundStyle = config.background_style || 'gradient';

  const getBackgroundStyle = () => {
    switch (backgroundStyle) {
      case 'solid':
        return { backgroundColor: primaryColor };
      case 'light':
        return { backgroundColor: '#f8f9fa' };
      case 'dark':
        return { backgroundColor: '#1f2937' };
      case 'gradient':
      default:
        return { background: `linear-gradient(135deg, ${primaryColor} 0%, var(--theme-primary-hover) 100%)` };
    }
  };

  const textColor = backgroundStyle === 'light' ? 'text-gray-900' : 'text-white';
  const subtitleColor = backgroundStyle === 'light' ? 'text-gray-600' : 'text-white/90';

  return (
    <section style={getBackgroundStyle()} className="py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className={`text-xl font-bold ${textColor} mb-3`}>
          {title}
        </h2>
        {subtitle && (
          <p className={`${subtitleColor} mb-6`} style={{ fontSize: '1rem' }}>
            {subtitle}
          </p>
        )}
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          {buttonText && buttonLink && (
            <Link
              to={buttonLink}
              className={`inline-flex items-center justify-center px-8 py-3 rounded-lg font-semibold transition-colors duration-200 ${
                backgroundStyle === 'light' 
                  ? 'bg-theme-blue text-white hover:bg-blue-600' 
                  : 'bg-white hover:bg-gray-100'
              }`}
              style={backgroundStyle !== 'light' ? { color: primaryColor } : {}}
            >
              <Calendar className="mr-2 h-5 w-5" />
              {buttonText}
            </Link>
          )}
          
          {showPhone && businessInfo?.phone && (
            <a
              href={`tel:${businessInfo.phone}`}
              className={`inline-flex items-center justify-center px-8 py-3 rounded-lg font-semibold transition-colors duration-200 ${
                backgroundStyle === 'light'
                  ? 'border-2 border-gray-900 text-gray-900 hover:bg-gray-900 hover:text-white'
                  : 'border-2 border-white text-white hover:bg-white'
              }`}
              style={backgroundStyle !== 'light' ? {} : {}}
              onMouseEnter={(e) => {
                if (backgroundStyle !== 'light') {
                  e.currentTarget.style.color = primaryColor;
                }
              }}
              onMouseLeave={(e) => {
                if (backgroundStyle !== 'light') {
                  e.currentTarget.style.color = 'white';
                }
              }}
            >
              <Phone className="mr-2 h-5 w-5" />
              Call: {businessInfo.phone}
            </a>
          )}
        </div>
      </div>
    </section>
  );
};

export default CTASectionComponent;
